export default __webpack_public_path__ + "static/media/senior-sample1.7d6b3f29.png";